<template>
    <div>
        <CRow>
            <CCol md="12">
                <CCard>
                    <CCardHeader>
                        <strong>{{$t('components.saleMethodMembers')}}</strong>
                    </CCardHeader>
                    <CCardBody>
                        <CRow>


                          <CCol col="6" >

                            <treeselect
                                v-model="person_id"

                                :async="true"
                                :load-options="load_persons"
                                :placeholder="$t('components.searchVisitor')"
                                :normalizer="normalizer_persons"
                            />

                          </CCol>

                        </CRow>
                    </CCardBody>
                    <CCardFooter>
                        <CButton  @click="insert_data()" type="submit" size="sm" color="primary">
                            <CIcon name="cil-check-circle"/>
                            {{$t('buttons.addSaleMethodMember')}}
                        </CButton>


                    </CCardFooter>
                </CCard>
            </CCol>
        </CRow>
        <CRow>
            <CCol md="12">
                <CCard>
                    <CCardHeader>
                        <strong>{{$t('components.saleMethods')}}</strong>
                    </CCardHeader>
                    <CCardBody>
                        <CDataTable
                                :items="items"
                                :fields="fields"

                                :items-per-page="20"
                                hover
                                sorter
                                pagination
                        >
                            <template #row="{item}">

                                <td>
                                    <p >{{item.row_id+1}}</p>

                                </td>

                            </template>
                            <template #methodTitle="{item}">

                                <td>
                                    <p >{{item.methodTitle}}</p>

                                </td>

                            </template>

                          <template #personName="{item}">

                            <td>
                              <p >
                                {{ item.personName }}
                              </p>
                            </td>

                          </template>
                            <template #operation="{item}">
                                <td >
                                    <CButton
                                            class="m-1"
                                            color="danger"
                                            variant="outline"
                                            square
                                            size="sm"
                                            :title="$t('buttons.delete')"
                                            @click="delete_item_dialog(item)"
                                    ><CIcon name="cilTrash" />
                                    </CButton>

                                </td>
                            </template>


                        </CDataTable>
                    </CCardBody>
                    <CCardFooter>

                    </CCardFooter>
                </CCard>
            </CCol>
        </CRow>

    </div>
</template>

<script>
    import axios from "axios";
    import {bus} from '../../../main';
    // import the styles
    import Treeselect from '@riophae/vue-treeselect'
    // import the styles
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
    var simulateAsync=null
    const simulateAsyncOperation = fn => {
        if(simulateAsync!=null){
            clearTimeout(simulateAsync)
        }
        simulateAsync =  setTimeout(fn, 1000)
    }

    var items = [];




    export default {
        name: 'Login',
        components: {
          Treeselect,

        },
        data() {
            return {

                validate_errors: [],
                name: '',
                file: '',
                color: '#ffffff',
                previewImage: '',
                description: '',
                items: items.map((item, row_id) => {
                    return {...item, row_id}
                }),
              person_id:null,
                fields : [
                    {key: 'row',label:this.$t('tables.row'), _style: 'width:10%'},
                    {key: 'methodTitle',label:this.$t('tables.saleMethod'), _style: 'width:10%'},
                    {key: 'personName',label:this.$t('tables.name'), _style: 'width:10%'},
                    {key: 'operation',label:this.$t('tables.operation'), _style: 'width:20%;'},
                ],

                document_product: null,

                details: [],
                collapseDuration: 0,
                status_form: 0,
              load_persons({action, searchQuery, callback}) {
                var self = this;

                if (action === ASYNC_SEARCH) {
                  simulateAsyncOperation(() => {
                    let options;
                    const formData = new FormData();

                    formData.append('SearchTxt', searchQuery);

                    axios.post('GetUsers', formData, {show_pros:true}).then(function (response) {
                      options = response.data.data;

                      callback(null, options);

                      // localStorage.setItem("api_token", response.data.access_token);
                      // self.$router.push({ path: 'notes' });
                    })
                        .catch(function (error) {
                          console.log(error);
                        });
                  })
                }
              },
              normalizer_persons(node) {
                return {
                  id: node.userId,
                    label: node.personCode +" "+ node.userName +" "+ node.surName+" "+ node.mobileNo,
                }
              },

            }
        },
        created() {
        },
        mounted() {
            this.$root.root_validate_errors = [];


            this.get_lists();
            bus.$on('delete_method_confirm', (data) => {
                // alert(data);
                if (data == "true") {
                    this.delete_item();

                } else {
                    this.status_form = 0;
                }
            });
        }, watch: {
            '$route.params.cat_id': function () {
                this.get_lists();
            },
            'selected_province': function () {
                console.log("peovince changed");
                this.get_cities();
            },
            'selected_city': function () {
                this.get_areas();
            }
        },
        methods: {
            validateForm: function () {
                this.$root.root_validate_errors = [];

                if (this.document_person != '' && this.selected_area != 0) {
                    return true;
                }


                // if (this.document_person == '') {
                //     this.$root.root_validate_errors.push('نام ویزیتور را وارد کنید');
                // }
                // if (this.selected_area == 0) {
                //     this.$root.root_validate_errors.push('محله را انتخاب کنید');
                // }

                return false;
                // e.preventDefault();
            },

            get_style(color) {
                return {
                    myStyle: {
                        backgroundColor: color
                    }
                }
            },
            edit_item(item) {
                // this.$set(this.items[item.id], '_toggled', !item._toggled)
                this.name = item.title;
                this.color = item.methodColor;

                this.status_form = item.id;
                // this.$nextTick(() => {
                //     this.collapseDuration = 0
                // })
            },
            emptyList() {
                // this.$set(this.items[item.id], '_toggled', !item._toggled)
                this.name = '';
                this.color = '';
                this.description = '';
                this.previewImage = '';
                this.status_form = 0;

                // this.$nextTick(() => {
                //     this.collapseDuration = 0
                // })
            },
            get_lists() {
                var self = this;

                const formData = new FormData();


                formData.append('Id', this.$route.params.method_id);

                axios.post('GetPersonMethodByMethodId', formData, {

                }).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        self.items = content_data.data.map((item, row_id) => {
                            return {...item, row_id}
                        });
                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }


                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            goSubCategories(item, index) {

                this.$router.push({path: '/categories/' + this.items[index].id});
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },

            insert_data() {

                if (!this.validateForm()) {
                    console.log("validate form is false" + this.validate_errors);
                    return true;
                }
                let self = this;
                const formData = new FormData();
                let url;
                    url = "AddPersonMethod";



                formData.append('MethodId', this.$route.params.method_id);
                formData.append('PersonId', this.person_id);
                // formData.append('AreaId', this.selected_area);
                axios.post(url, formData, {}).then((res) => {



                    self.status_form = 0;
                    self.name = '';
                    self.color = '';
                    self.description = '';
                    self.previewImage = '';
                    self.get_lists();

                    self.$root.modal_component.show_api_response_modals(res);

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            delete_item_dialog(item) {

                this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], 'delete_method_confirm');

                this.status_form = item.personId;

            }, delete_item() {


                let self = this;
                const formData = new FormData()
                let url;
                url = "DeletePersonMethod";


                formData.append('PersonId', this.status_form);

                axios.post(url, formData, {}).then((res) => {

                    self.$root.modal_component.show_api_response_modals(res);

                    self.status_form = 0;

                    self.get_lists();


                })
                    .catch(function (error) {

                        console.log(error);
                    });
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },
        }
    }

</script>
